export default class FormValidator{

    ERROR_FIELD_OK = 0;
    ERROR_FIELD_REQUIRED = 1;
    ERROR_FIELD_MIN_ERROR = 2;
    ERROR_FIELD_MAX_ERROR = 3;
    ERROR_FIELD_INVALID = 4;
    ERROR_EMAIL_INVALID = 5;
    ERROR_PHONE_INVALID = 6;

    constructor( rules, initValues ){
        this._values = {};
        this._rules = rules;
        for( const field in initValues ){
            this.setValue( field, initValues[field] ).then( () => {}, () => {} );
        }
    }

    setValue(fieldName, value) {
        return new Promise((resolve, reject) => {
            this._values[fieldName] = {
                value,
                valid: false
            }

            this.validateField(fieldName, value).then((result) => {
                this._values[fieldName].valid = true;


                if (this._values[fieldName].valid) {
                    resolve(result);
                }

            }, reject);
        });
    }

    validateField( fieldName, value ){
        return new Promise((resolve, reject) => {
            switch( this._rules[fieldName].type ){
                case 'email':
                    this.validateEmail( value ).then( resolve, reject );
                break;
                case 'string':
                    this.validateString( value, this._rules[fieldName] ).then( resolve, reject );
                break;
                case 'string-copy':
                    this.validateStringCopy( value, this._rules[fieldName] ).then( resolve, reject );
                break;
                case 'strong_password':
                    this.validateStrongPassword( value, this._rules[fieldName] ).then( resolve, reject );
                break;
                case 'email_or_phone':
                    this.validateEmailOrPhone(value, this._rules[fieldName]).then(resolve, reject);
                break;
                case 'number':
                    this.validateNumber(value, this._rules[fieldName]).then(resolve, reject);
                break;
                default:
                    resolve( this.ERROR_FIELD_OK );
                break;
            }
        });
    }



    validateEmail(value){
        return new Promise((resolve, reject) => {
            const val = value??value.toString();

            if( !value && rule.required ){
                return reject( this.ERROR_FIELD_REQUIRED );
            } else if( !value && !rule.required ) {
                return resolve( this.ERROR_FIELD_OK );
            }

            const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if( !regex.test(value.toLowerCase()) ){
                return reject( this.ERROR_FIELD_INVALID );
            }
            return resolve( this.ERROR_FIELD_OK );
        });
    }

    validateString( value, rule ){
        return new Promise((resolve, reject) => {
            const val = typeof value === 'string' ? value.trim() : (value ?? '').toString().trim();

            if( !value && rule.required ){
                return reject( this.ERROR_FIELD_REQUIRED );
            } else if( !value && !rule.required ) {
                return resolve( this.ERROR_FIELD_OK );
            }

            if( rule.min && val.length < rule.min ){
                return reject( this.ERROR_FIELD_MIN_ERROR );
            }

            if( rule.max && val.length > rule.max ){
                return reject( this.ERROR_FIELD_MAX_ERROR );
            }

            return resolve( this.ERROR_FIELD_OK );
        });
    }

    validateStringCopy( value, rule ){
        return new Promise((resolve, reject) => {

            const val = value != null ? value.toString() : '';

            if( !val && rule.required ){
                return reject( this.ERROR_FIELD_REQUIRED );
            } else if( !val && !rule.required ) {
                return resolve( this.ERROR_FIELD_OK );
            }

            if( rule.min && val.length < rule.min ){
                return reject( this.ERROR_FIELD_MIN_ERROR );
            }

            if( rule.max && val.length > rule.max ){
                return reject( this.ERROR_FIELD_MAX_ERROR );
            }

            const lettersRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;
            if( !lettersRegex.test(val) ){
                return reject( this.ERROR_FIELD_INVALID );
            }

            return resolve( this.ERROR_FIELD_OK );
        });
    }

    validateStrongPassword(value, rule) {
        return new Promise((resolve, reject) => {
            const val = value?.toString().trim() ?? '';

            if (!val && rule.required) {
                return reject(this.ERROR_FIELD_REQUIRED);
            } else if (!val && !rule.required) {
                return resolve(this.ERROR_FIELD_OK);
            }

            if (rule.min && val.length < rule.min) {
                return reject(this.ERROR_FIELD_MIN_ERROR);
            }

            if (rule.max && val.length > rule.max) {
                return reject(this.ERROR_FIELD_MAX_ERROR);
            }

            const hasUpper = /[A-Z]/.test(val);
            const hasLower = /[a-z]/.test(val);
            const hasNumber = /[0-9]/.test(val);
            const hasSymbol = /[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/]/.test(val);

            const hasDangerousRepetition = /(.)\1{2,}/.test(val);

            if (!hasUpper || !hasLower || !hasNumber || !hasSymbol || hasDangerousRepetition) {
                return reject(this.ERROR_FIELD_INVALID);
            }

            return resolve(this.ERROR_FIELD_OK);
        });
    }


    validateEmailOrPhone(value, rule) {
        return new Promise((resolve, reject) => {
            const val = value?.toString().trim() ?? '';

            if (!val && rule.required) {
                return reject(this.ERROR_FIELD_REQUIRED);
            } else if (!val && !rule.required) {
                return resolve(this.ERROR_FIELD_OK);
            }

            const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const usPhoneRegex = /^\d{10}$/;

            const isEmail = emailRegex.test(val.toLowerCase());
            const isPhone = usPhoneRegex.test(val);

            if (!isEmail && !isPhone) {
                if (val.includes('@')) {
                    return reject(this.ERROR_EMAIL_INVALID);
                } else {
                    return reject(this.ERROR_PHONE_INVALID);
                }
            }

            return resolve(this.ERROR_FIELD_OK);
        });
    }

    validateNumber(value, rule) {
        return new Promise((resolve, reject) => {
            const val = value?.toString().trim() ?? '';

            if (!val && rule.required) {
                return reject(this.ERROR_FIELD_REQUIRED);
            } else if (!val && !rule.required) {
                return resolve(this.ERROR_FIELD_OK);
            }

            const allowedCharsRegex = /^\+?[0-9]+$/;
            if (!allowedCharsRegex.test(val)) {
                return reject(this.ERROR_PHONE_INVALID);
            }

            if (rule.min && val.length < rule.min) {
                return reject(this.ERROR_FIELD_MIN_ERROR);
            }

            if (rule.max && val.length > rule.max) {
                return reject(this.ERROR_FIELD_MAX_ERROR);
            }

            return resolve(this.ERROR_FIELD_OK);
        });
    }

    isValid(){
        for( const field in this._values ){
            if( !this._values[field].valid ){
                return false;
            }
        }
        return true;
    }

    reset(){
        this._values = {};
    }

}
